import { db } from '../firebase';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, deleteDoc, query, orderBy, where } from 'firebase/firestore';
import { getCurrentUserPermission, getEffectiveUserId } from './userService';

const clientCollection = collection(db, "clients");

// Vérifie la permission "clients" de l'utilisateur courant
async function assertClientsAccess() {
  const perm = await getCurrentUserPermission("clients");
  return perm !== "none";
}

export const fetchClients = async () => {
  if (!(await assertClientsAccess())) return [];
  const userId = await getEffectiveUserId();
  const clientQuery = query(
    clientCollection, 
    where("userId", "==", userId),
    orderBy("order")
  );
  const querySnapshot = await getDocs(clientQuery);
  return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })) || [];
};

export const getClientById = async (id) => {
  if (!(await assertClientsAccess())) return null;
  const clientRef = doc(db, "clients", id);
  const clientDoc = await getDoc(clientRef);
  if (clientDoc.exists()) {
    return { id: clientDoc.id, ...clientDoc.data() };
  } else {
    throw new Error("Client not found");
  }
};

export const addClient = async (client) => {
  if (!(await assertClientsAccess())) return null;
  const userId = await getEffectiveUserId();
  // Vous pouvez également ajouter le userId dans le document si besoin
  const clients = await fetchClients();
  const newOrder = clients.length > 0 ? clients[clients.length - 1].order + 1 : 0;
  const newClient = { ...client, order: newOrder, userId };

  const docRef = await addDoc(clientCollection, newClient);
  return { id: docRef.id, ...newClient };
};

export const updateClient = async (client) => {
  if (!(await assertClientsAccess())) return;
  const clientRef = doc(db, "clients", client.id);
  await updateDoc(clientRef, { ...client });
};

export const deleteClient = async (clientId) => {
  if (!(await assertClientsAccess())) return;
  if (!clientId) {
    return;
  }
  const clientRef = doc(db, "clients", clientId);
  await deleteDoc(clientRef);
};